import React from 'react';
import PropTypes from 'prop-types';
import Navbar from './navbar';
import AppPlayerContainer from './app-player';

class Page extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        const {
            role, moduleId, pageCount, pageNum, sessionNum, pageTitle, pageTitleLink, children, requiredNodeNotCompleted,
            previousPage, nextPage, prevBtnDisabled, nextBtnDisabled, refreshSlide, sectionTitle, preventMultiClick,
            exitViewer, collapsed, activeSectionPagesList, extendedContentEditing, submitting, takingAssessment,
        } = this.props;

        let playerLeftFullWidth = { width: 'calc(100% - 210px)' };
        if(collapsed) {
            playerLeftFullWidth = { width: '100%' };
        }

        return (
            <div className="jre-player">
                <header>
                    <Navbar
                        role={role}
                        moduleId={moduleId}
                        pageCount={pageCount}
                        pageNum={pageNum}
                        sessionNum={sessionNum}
                        sectionTitle={sectionTitle}
                        title={pageTitle}
                        titleLink={pageTitleLink}
                        exitViewer={exitViewer}
                        activeSectionPagesList={activeSectionPagesList}
                        submitting={submitting || takingAssessment}
                    />
                </header>

                <main className="playerouter" style={playerLeftFullWidth}>
                    {children}
                </main>

                <footer className="diviplbottom">
                    <AppPlayerContainer
                        previousPage={previousPage}
                        nextPage={nextPage}
                        prevBtnDisabled={prevBtnDisabled}
                        nextBtnDisabled={nextBtnDisabled}
                        refreshSlide={refreshSlide}
                        extendedContentEditing={extendedContentEditing}
                        submitting={submitting}
                        takingAssessment={takingAssessment}
                        preventMultiClick={preventMultiClick}
                        requiredNodeNotCompleted={requiredNodeNotCompleted}
                    />
                </footer>
            </div>
        );
    }
}

Page.propTypes = {
    pageTitle: PropTypes.string,
    pageTitleLink: PropTypes.string
};

export default Page;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/page/page.js